import { combineReducers } from 'redux';
import types from './types';

/* State Shape
{
    isShowing: bool,
    isPlaying: bool,
    isProcessing: bool,
    isShowingCloseConfirmation: bool,
    lastSplitterPlacementPosition: number,
    audio: null || {
      id: string,
      durationMS: number,
      url: string
    }
    audioSplitter: {
      durationMS: number,
      splits: [{
        id: number,
        position: number,
      }],
      splitter: {
        position: number,
      },
      activeSplitId: null || number,
      isSHowingSplitButton: boolean,
    },
}
*/

const initialState = {
  isShowing: false,
  isPlaying: false,
  isProcessing: false,
  isShowingCloseConfirmation: false,
  audio: null,
  lastSplitterPlacementPosition: 0,
  audioSplitter: {
    durationMS: 0,
    splits: [],
    splitter: {
      position: 0,
    },
    activeSplitId: null,
    isShowingSplitButton: false,
  },
};

const isShowingReducer = (state = initialState.isShowing, action) => {
  switch (action.type) {
    case types.SET_IS_SHOWING:
      return action.payload.isShowing;
    case types.RESET_STORE:
      return initialState.isShowing;
    default:
      return state;
  }
};

const isPlayingReducer = (state = initialState.isPlaying, action) => {
  switch (action.type) {
    case types.SET_IS_PLAYING:
      return action.payload.isPlaying;
    case types.RESET_STORE:
      return initialState.isPlaying;
    default:
      return state;
  }
};

const isShowingCloseConfirmationReducer = (
  state = initialState.isShowingCloseConfirmation,
  action
) => {
  switch (action.type) {
    case types.SET_IS_SHOWING_CLOSE_CONFIRMATION:
      return action.payload.isShowingCloseConfirmation;
    case types.RESET_STORE:
      return initialState.isShowingCloseConfirmation;
    default:
      return state;
  }
};

const isProcessingReducer = (state = initialState.isProcessing, action) => {
  switch (action.type) {
    case types.SET_IS_PROCESSING:
      return action.payload.isProcessing;
    case types.RESET_STORE:
      return initialState.isProcessing;
    default:
      return state;
  }
};

const lastSplitterPlacementPositionReducer = (
  state = initialState.lastSplitterPlacementPosition,
  action
) => {
  switch (action.type) {
    case types.SET_LAST_SPLITTER_PLACEMENT_POSITION:
      return action.payload.lastSplitterPlacementPosition;
    case types.RESET_STORE:
      return initialState.lastSplitterPlacementPosition;
    default:
      return state;
  }
};

const audioReducer = (state = initialState.audio, action) => {
  switch (action.type) {
    case types.SET_AUDIO:
      return action.payload.audio;
    case types.RESET_STORE:
      return initialState.audio;
    default:
      return state;
  }
};

const audioSplitterDurationMSReducer = (
  state = initialState.audioSplitter.durationMS,
  action
) => {
  switch (action.type) {
    case types.SET_AUDIO_SPLITTER_DURATION_MS:
      return action.payload.audioSplitterDurationMS;
    case types.RESET_STORE:
      return initialState.audioSplitter.durationMS;
    default:
      return state;
  }
};

const audioSplitterSplitsReducer = (
  state = initialState.audioSplitter.splits,
  action
) => {
  switch (action.type) {
    case types.SET_AUDIO_SPLITTER_SPLITS:
      return action.payload.audioSplitterSplits;
    case types.ADD_AUDIO_SPLITTER_SPLIT:
      return [...state, action.payload.audioSplitterSplit];
    case types.REMOVE_AUDIO_SPLITTER_SPLIT:
      return state.filter(
        split => split.id !== action.payload.audioSplitterSplit.id
      );
    case types.RESET_STORE:
      return initialState.audioSplitter.splits;
    default:
      return state;
  }
};

const audioSplitterSplitterReducer = (
  state = initialState.audioSplitter.splitter,
  action
) => {
  switch (action.type) {
    case types.SET_AUDIO_SPLITTER_SPLITTER:
      return action.payload.audioSplitterSplitter;
    case types.RESET_STORE:
      return initialState.audioSplitter.splitter;
    default:
      return state;
  }
};

const audioSplitterActiveSplitIdReducer = (
  state = initialState.audioSplitter.activeSplitId,
  action
) => {
  switch (action.type) {
    case types.SET_AUDIO_SPLITTER_ACTIVE_SPLIT_ID:
      return action.payload.audioSplitterActiveSplitId;
    case types.RESET_STORE:
      return initialState.audioSplitter.activeSplitId;
    default:
      return state;
  }
};

const audioSplitterIsSHowingSplitButtonReducer = (
  state = initialState.audioSplitter.isShowingSplitButton,
  action
) => {
  switch (action.type) {
    case types.SET_AUDIO_SPLITTER_IS_SHOWING_SPLIT_BUTTON:
      return action.payload.audioSplitterIsSHowingSplitButton;
    case types.RESET_STORE:
      return initialState.audioSplitter.isShowingSplitButton;
    default:
      return state;
  }
};

const reducer = combineReducers({
  isShowing: isShowingReducer,
  isPlaying: isPlayingReducer,
  isProcessing: isProcessingReducer,
  isShowingCloseConfirmation: isShowingCloseConfirmationReducer,
  lastSplitterPlacementPosition: lastSplitterPlacementPositionReducer,
  audio: audioReducer,
  audioSplitter: combineReducers({
    durationMS: audioSplitterDurationMSReducer,
    splits: audioSplitterSplitsReducer,
    splitter: audioSplitterSplitterReducer,
    activeSplitId: audioSplitterActiveSplitIdReducer,
    isShowingSplitButton: audioSplitterIsSHowingSplitButtonReducer,
  }),
});

export default reducer;
